import { z } from 'zod';
import { DIRECTOR_MESSAGE_MAX_LEN, DIRECTOR_MESSAGE_MIN_LEN } from '../constants.js';
export const createDirectorMessageSchema = z.object({
    text: z.string().trim().min(DIRECTOR_MESSAGE_MIN_LEN).max(DIRECTOR_MESSAGE_MAX_LEN),
});
